'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './help.routes';

export class HelpComponent {
  /*@ngInject*/
  constructor() {
    this.message = 'Hello';
  }
}

export default angular.module('appApp.help', [uiRouter])
  .config(routes)
  .component('help', {
    template: require('./help.html'),
    controller: HelpComponent,
    controllerAs: 'helpCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/help/help.component.js